import TemplateView from "../../TemplateView"
import messageResource from '../../messageResource'
import {getInstance as getPermissionTooltip} from '../../SimpleSingletonTooltip'

export default class PermissionIcons extends TemplateView {
    constructor({
        manageUsers = false,
        modifyTimeTrack = false,
        manageScope = false,
        costReports = false,
        showCostReports = false,
        modifyTimeTrackTooltipText = "",
        costReportsTooltipText = "",
    }) {
        super()
        this.manageUsers = manageUsers
        this.modifyTimeTrack = modifyTimeTrack
        this.manageScope = manageScope
        this.costReports = costReports
        this.showCostReports = showCostReports
        this.costReportsTooltipText = costReportsTooltipText
        this.modifyTimeTrackTooltipText = modifyTimeTrackTooltipText
    }

    templateHtml() {
        return "<div class='permissionIcons'>" +
               "  <div class='manageUsers icon'></div>" +
               "  <div class='modifyTimeTrack icon'></div>" +
               "  <div class='manageScope icon'></div>" +
               "  <div class='iconWrapper'>" +
               "    <div class='costReports icon'></div>" +
               "  </div>" +
               "</div>"
    }

    afterRender() {
        this.$el.toggleClass("hasManageUsers", this.manageUsers)
        this.$el.toggleClass("hasModifyTimeTrack", this.modifyTimeTrack)
        this.$el.toggleClass("hasManageScope", this.manageScope)

        this.find(".costReports").toggle(this.showCostReports)

        this.permissionNameTooltip = getPermissionTooltip()

        this.permissionNameTooltip.subscribeToMouseEvents(this.find('.manageUsers'), () => {
            this.permissionNameTooltip.setState({
                text: messageResource.getMessage('access_rights.manage_users'),
                extraClass: '',
            })
        })
        this.permissionNameTooltip.subscribeToMouseEvents(this.find('.modifyTimeTrack'), () => {
            this.permissionNameTooltip.setState({
                text: this.modifyTimeTrackTooltipText,
                extraClass: '',
            })
        })
        this.permissionNameTooltip.subscribeToMouseEvents(this.find('.manageScope'), () => {
            this.permissionNameTooltip.setState({
                text: messageResource.getMessage('access_rights.edit_hierarchy'),
                extraClass: '',
            })
        })
        if (this.showCostReports) {
            this.$el.toggleClass("hasCostReports", this.costReports)
            this.permissionNameTooltip.subscribeToMouseEvents(this.find('.costReports'), () => {
                this.permissionNameTooltip.setState({
                    text: this.costReportsTooltipText,
                    extraClass: '',
                })
            })
        }
    }
}



// WEBPACK FOOTER //
// ./web/js/panels/usersAssignedToHierarchy/PermissionIcons.js